import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { FindSalesRepresentativesParams } from './salesRepresentatives.types';

export const getFindSalesRepresentativesKey = (
  params: FindSalesRepresentativesParams,
): UseDataQuery['queryKey'] => [DataQueryKey.SALES_REPRESENTATIVES, undefined, params ?? {}];
